export enum InsuredValueEnum {
  Yes = 'Yes',
  No = 'No',
  MinK = 'MinK',
  MaxK = 'MaxK'
}
